import JOIN from "../assets/images/join-us/join-us-hero.jpg";
import CSA from "../assets/images/csa/csa-hero.jpg";
import EVENT from "../assets/images/event/events-hero.jpg";
import EDUCATION from "../assets/images/education/education-hero.png";
import PUBLICATIONS from "../assets/images/publications/publications-hero.png";
import PROJECT from "../assets/images/aboutTheFarm/the-project-hero.jpg";
import GALLERY from "../assets/images/gallery/gallery-hero.jpg";
import MEMBERSHIPS from "../assets/images/membership/membership-hero.jpg";
import SUPPORT from "../assets/images/support/support-us-hero.jpg";
import SPONSORS from "../assets/images/sponsors/sponsor-hero.jpg";
import {
  getPublicNavLayout,
  resolvePublicNavDate,
} from "../config/publicNavLinks";

export const infoCards = [
  {
    image: JOIN,
    altText: "Alnarp Farm Members",
    imageTitle: "Join Us",
    body: {
      body: "Get involved with the farm. We are always open to new people joining the project! Everyone is welcome.",

      buttonText: "Join Us",
      link: "/join",
    },
  },
  {
    image: EVENT,
    altText: "events",
    imageTitle: "Events",
    body: {
      body: "We offer a veirty of events and workshops. Come learn,dance, enjoy a warm meal with us.",
      buttonText: "Events",
      link: "/events",
    },
  },
  {
    image: CSA,
    altText: "CSA: the weekly veggie box",
    imageTitle: "CSA",
    body: {
      body: "We offer organically grown vegetables in the box each week. Space is limited so sign up today to avoid missing out.",
      buttonText: "CSA",
      link: "/csa",
    },
  },
  {
    image: EDUCATION,
    altText: "Education at Alnarp for students",
    imageTitle: "Education",
    body: {
      body: "If you are an SLU student, there are many opportunities for earning academic credits while working on Alnarp’s Farm.",
      buttonText: "Education",
      link: "/education",
    },
  },
  {
    image: PUBLICATIONS,
    altText: "Publications and interesting news",
    imageTitle: "Publications",
    body: {
      body: "Share and read knowledgable papers contributed by our community.",
      buttonText: "Publications",
      link: "/publications",
    },
  },
  {
    image: PROJECT,
    altText: "The project",
    imageTitle: "The Project",
    body: {
      body: "Read more about the project and our vision for the farm.",
      buttonText: "The Project",
      link: "/about-project",
    },
  },
  {
    image: GALLERY,
    altText: "Gallery",
    imageTitle: "Gallery",
    body: {
      body: "Check out our gallery of photos and videos from the farm.",
      buttonText: "Gallery",
      link: "/gallery",
    },
  },
  {
    image: MEMBERSHIPS,
    altText: "Memberships",
    imageTitle: "Memberships",
    body: {
      body: "Buy a membership to support the farm and get access to exclusive benefits.",
      buttonText: "Memberships",
      link: "/memberships",
    },
  },
  {
    image: SUPPORT,
    altText: "Support us",
    imageTitle: "Support us",
    body: {
      body: "Support the farm by donating to our crowdfunding campaign.",
      buttonText: "Support us",
      link: "/support-us",
    },
  },
  {
    image: SPONSORS,
    altText: "sponsors",
    imageTitle: "sponsors",
    body: {
      body: "Our sponsors are the backbone of the farm. We are grateful for their support.",
      buttonText: "sponsors",
      link: "/sponsors",
    },
  },
];

export type HomeInfoCard = (typeof infoCards)[number];

/** Matches public nav link order (excludes Home). Respects seasonal nav layout. */
export function getOrderedInfoCards(
  date: Date = resolvePublicNavDate(),
): HomeInfoCard[] {
  const { hamburgerLinks } = getPublicNavLayout(date);
  const linkOrder = hamburgerLinks
    .filter((link) => link.to !== "/")
    .map((link) => link.to);

  const cardByLink = new Map(
    infoCards.map((card) => [card.body.link, card] as const),
  );

  return linkOrder
    .map((link) => cardByLink.get(link))
    .filter((card): card is HomeInfoCard => card !== undefined);
}
